import React from 'react';
import { SvgIconProps } from '../types';

export default function Clock({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M26.8295 18.2394H19.2222V8.44741C19.2222 7.66947 18.6296 7.04373 17.8929 7.04373C17.1562 7.04373 16.5636 7.66947 16.5636 8.44741L16.4355 21.1313H26.8135C27.5662 21.1313 28.1748 20.4717 28.1748 19.6938C28.1909 18.8989 27.5822 18.2394 26.8295 18.2394Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0008 33.0014C26.2854 33.0014 33.0014 26.2854 33.0014 18.0008C33.0014 9.71615 26.2854 3.00013 18.0008 3.00013C9.71615 3.00013 3.00013 9.71615 3.00013 18.0008C3.00013 26.2854 9.71615 33.0014 18.0008 33.0014ZM18.0008 36.0015C27.9423 36.0015 36.0015 27.9423 36.0015 18.0008C36.0015 8.05922 27.9423 0 18.0008 0C8.05922 0 0 8.05922 0 18.0008C0 27.9423 8.05922 36.0015 18.0008 36.0015Z"
        fill={fill}
      />
    </svg>
  );
}
